import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  FormControl,
} from '@angular/forms'
import {Observable, EMPTY} from 'rxjs'
import {finalize, catchError} from 'rxjs/operators'

export abstract class FormBasedComponent {
  form: FormGroup

  protected submitted = false
  submitting = false

  constructor(protected formBuilder: FormBuilder) {}

  initForm() {
    this.form = this.buildForm(this.formBuilder)
    this.reset()
  }

  protected abstract buildForm(builder: FormBuilder): FormGroup

  showFieldInvalid(field: string) {
    const ctrl: AbstractControl = this.form.get(field)
    if (ctrl instanceof FormControl) {
      const invalid = this.isFieldInvalid(ctrl)
      return invalid
    }
    throw new Error(field + ' is not a valid field for this form')
  }

  isFieldInvalid(ctrl: FormControl) {
    return (ctrl.touched || ctrl.dirty) && ctrl.invalid
  }

  showFormInvalid() {
    return this.submitted && this.form.invalid && this.form.errors
  }

  protected abstract processSubmit(form: FormGroup): Observable<any>

  submit() {
    this.submitting = true
    let sub = this.processSubmit(this.form)
      .pipe(
        catchError((err: Error) => {
          this.form.setErrors({global: err.message})
          return EMPTY
        }),
        finalize(() => {
          this.submitting = false
          this.submitted = true
          sub.unsubscribe()
        }),
      )
      .subscribe()
  }

  protected abstract get defaults(): any

  reset(values?: any) {
    this.submitted = false
    if (!values) {
      values = this.defaults
    }
    this.form.reset(values)
  }

  submitHelper(event) {
    if (event.path) {
      let button = event.path.find((el) => el.nodeName == 'BUTTON')
      if (button && button.disabled) {
        for (let key in this.form.controls) {
          this.form.controls[key].markAsTouched()
        }
      }
    }
  }

  trim(value) {
    if (value && typeof value == 'string') {
      return value.trim()
    }
    return value
  }
}
